module.exports = __webpack_public_path__ + "img/Ec.56c493b2.png";